import { useDispatch, useSelector } from "react-redux";
import { getProductData, setSidebarExpended, setPromptRequest } from "../../../models/generateSlice";
import ChooseProductView from "./ChooseProductView";
import { Spinner } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPromptRequestFromFirebase } from "../../../models/firebaseModel";

const ChooseProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminKey = useSelector((state) => state.auth.adminKey);
  const productList = useSelector((state) => state.generate.productsData);
  const productStatus = useSelector((state) => state.generate.productStatus);
  const [isReady, setIsReady] = useState(true);

  useEffect(() => {
    if (productList.length > 0) {
      setIsReady(false);
      getPromptRequestFromFirebase(dispatch, setPromptRequest).then((model) => {
        setIsReady(true);
        if (model) {
          const product = productList.find((product) => product.lora_model_name === model);
          dispatch(setSidebarExpended(false));
          navigate(`/generate/model/${product.name}`);
        }
      });
    } else {
      dispatch(getProductData(adminKey));
    }
  }, [dispatch, adminKey, productList]);

  const handleSelectProduct = (product) => {
    dispatch(setSidebarExpended(false));
    dispatch(
      setPromptRequest({
        model: product.lora_model_name,
        triggerWord: product.trigger_word,
      }),
    );
    navigate(`/generate/model/${product.name}`);
  };

  const ProductDataResultsRender = () => {
    if (productStatus === "succeeded" && isReady) {
      return <ChooseProductView products={productList} selectProduct={handleSelectProduct} />;
    }
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" label="Loading..." color="white" />
      </div>
    );
  };

  return ProductDataResultsRender();
};

export default ChooseProduct;
